import FeeItemRuleRequest from './fee-item-rule-request.entity';

export default class ContractFee {
  feeStrategy: string;

  feeType: string;

  periodStart: string;

  periodEnd: string;

  rules: Array<FeeItemRuleRequest> = [];

  constructor(obj: any = {}) {
    this.feeStrategy = obj.feeStrategy || '';
    this.feeType = obj.feeType || '';
    this.periodStart = obj.periodStart || '';
    this.periodEnd = obj.periodEnd || '';
    this.rules = obj.rules || [];
  }

  public static of(obj: any = {}): ContractFee {
    return new ContractFee(obj || {});
  }

  public static ofList(obj: any[]): ContractFee[] {
    return obj.map(this.of);
  }
}
